// Copyright 2022 Foursquare Labs, Inc. All Rights Reserved.

'use client';

export {
  Root as Collapsible,
  CollapsibleTrigger as CollapsibleTrigger,
  CollapsibleContent as CollapsibleContent,
} from '@radix-ui/react-collapsible';
